import { I18n } from 'aws-amplify'

const Strings = () => ({
  toggle: I18n.get('Toggle'),
  darkMode: I18n.get('dark mode'),
  lightMode: I18n.get('light mode'),
  systemMode: I18n.get('system mode')
})

export default Strings